import { Loader2 } from 'lucide-react';

export default function SmallLoader() {
    return (
        <div className="flex justify-center">
            <Loader2 className="size-4 animate-spin text-muted-foreground" />
            <span className="sr-only">Loading...</span>
        </div>
    );
}
